import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

 const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_2bjsvse', 'template_irt8tru', form.current, 'mKS3wndidyCjYKyL4')
      .then((result) => {
          console.log(result.text);
          console.log("message sent succesfull");
      }, (error) => {
          console.log(error.text);
      });
  };

  return (
    <div
    id='content-body'
    className='d-flex flex-column align-items-center col-12 col-md-9 col-xl-10 pl-4 pr-4 bd-content overflow-auto'
  >
    <div className='mb-8' style={{ height: '60px' }}>
        <div className='col-md-12 pt-4'>
          <h2>Contact Administrateur</h2>
        </div>
      </div>
      <div
        className='text-center mt-5'
        
      >
    <form ref={form} onSubmit={sendEmail} 
     className='mb-5 d-flex flex-column align-items-center '
     style={{ width: '150%' }}>

       <div className='d-flex justify-content-center align-items-center mb-4'>
       <span className='d-inline-block me-2'> Name</span>
     
      <input type="text" name="user_name"  className='w-75 px-4 py-4 border rounded-lg'/>
      </div>
      <div className='d-flex justify-content-center align-items-center mb-4'>
       <span className='d-inline-block me-2'>Email</span>
      <input type="email" name="user_email"  className='w-100 mw-100 px-4 py-4 border rounded-lg' />
      </div>
      <div className='d-flex justify-content-center align-items-center mb-4'>
       <span className='d-inline-block me-2'>Message</span>
      <textarea name="message" className='w-75 px-4 py-4 border rounded-lg'/>
      </div>
      <div className='col-12'>
      <input type="submit" value="Send"  className='bg-primary text-white py-2 px-4 rounded border border-0 fw-bold ms-5'/>
      </div>
    </form>
    </div>
    <div className='row position-absolute bottom-0 start-25 w-75'>
      <div className='col-md-12 py-3'>
        <span className='footer-text-1'>Energy Tip: </span>
        <span className='footer-text-2'>
          On all days, turning off or unplugging electrical devices when
          you're not at departments can help reduce your energy costs by
          approximately 10 percent.
        </span>
      </div>
    </div>
    </div>
    

  );
};
export default Contact;